import { render } from "./CardReceitaXilema.vue?vue&type=template&id=1d0892fe&scoped=true"
import script from "./CardReceitaXilema.vue?vue&type=script&lang=js"
export * from "./CardReceitaXilema.vue?vue&type=script&lang=js"

import "./CardReceitaXilema.vue?vue&type=style&index=0&id=1d0892fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0892fe"]])

export default __exports__